module.exports = fox._r("images/promo/tutorial/05.png", __webpack_public_path__ + "_/common/images/promo/tutorial/05.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/05.png
// module id = 654
// module chunks = 2